// removed by extract-text-webpack-plugin
module.exports = {"root":"_1lIJw","inner":"_3tvMG","centered":"_BeKlq","header":"_OKH6b","title":"_3MPQN","closeButton":"_1SHQo","body":"_3tbun","figure":"_1mANZ","footer":"_2P80N","ghost":"_2JNEa"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Account/children/AccountSubscriptions/components/ChangeSubscriptionModal/ChangeSubscriptionModal.scss
// module id = 890
// module chunks = 34